/**
 *
 * @param {number} num
 * @returns {string}
 */
const toHex = (num) => {
  //   return num.toString(16).padStart(2, "0");
  return num.toString(16).length === 1
    ? `0${num.toString(16)}`
    : num.toString(16);
};

/**
 * @param {string} hexColor #000000
 * @returns {[number,number,number]} [r,g,b]
 */
const toRGB = (hexColor) => {
  const [r1, r2, g1, g2, b1, b2] = hexColor.replace("#", "").split("");
  return [
    parseInt(`${r1}${r2}`, 16),
    parseInt(`${g1}${g2}`, 16),
    parseInt(`${b1}${b2}`, 16),
  ];
};
/**
 * @param {number} max 0~256
 * @returns {number}
 */
const random = (max = 256) => Math.floor(Math.random() * max);

const LUMA = [0.2126, 0.7152, 0.0722];

module.exports = {
  LUMA,
  random,
  toRGB,
  toHex,
};
